import type {ComponentProps, FC} from 'react';

import type {ProductSizeFragment} from '@/modules/commerce/product-size/query';
import {Heading} from '@/modules/foundation/components/typography/heading';

import {RadioTile} from '../form/RadioTile';

import type {ProductSizeConfiguration} from './configuration';

export type ProductColorSelectorProps = ComponentProps<'fieldset'> & {
	sizes: ProductSizeFragment[];
	namePrefix?: string;
	defaultConfiguration: ProductSizeConfiguration | null;
	legend?: string;
};

export const ProductSizeSelector: FC<ProductColorSelectorProps> = ({
	sizes,
	namePrefix,
	defaultConfiguration,
	legend,
	...rest
}) => {
	const sizesById = sizes.reduce((acc, size) => {
		if (size) {
			acc.set(size._id, size);
		}

		return acc;
	}, new Map<string, ProductSizeFragment>());

	const uniqueSizes = sizesById ? Array.from(sizesById.values()) : [];

	return (
		<fieldset {...rest}>
			{legend && (
				<Heading size="h3" asChild className="mb-3">
					<legend>{legend}</legend>
				</Heading>
			)}
			<div className="flex flex-wrap gap-2">
				{uniqueSizes.map((size) => (
					<RadioTile
						key={size._id}
						value={size._id}
						name={namePrefix}
						defaultChecked={defaultConfiguration === size._id}
					>
						{size.name}
					</RadioTile>
				))}
			</div>
		</fieldset>
	);
};
